module.exports = __webpack_public_path__ + "static/media/support.8d1c30e0.png";